var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":"signatureBox"}},[_vm._v(_vm._s(_vm.element.text))]),_vm._v(" "),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center",attrs:{"id":"signatureBox"}},[_c('h4',[_vm._v("Auf mobilen Geräten kann hier unterschrieben werden.")])])
}]

export { render, staticRenderFns }